// assets/ajax-cart.js
$(document).ready(function() {
    // Function to update the cart
    function updateCart() {
        $.getJSON('/cart.js', function(cart) {
            // Update cart item count
            $('#cart-count').text(cart.item_count);
            // Update cart subtotal
            $('.cart-subtotal__price').text(Shopify.formatMoney(cart.total_price));
            // Update each cart item
            cart.items.forEach(function(item, index) {
                $('.un-line-item-unit-price[data-id="' + item.key + '"]').text(Shopify.formatMoney(item.price));
                $('.un-line-item-total[data-id="' + item.key + '"]').text(Shopify.formatMoney(item.line_price));
                $('#updates_large_' + item.key).val(item.quantity);
            });
        });
    }

    // Add to cart button
    $('.add-to-cart').on('click', function(e) {
        e.preventDefault();
        var form = $(this).closest('form');
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: form.serialize(),
            dataType: 'json',
            success: function(item) {
                updateCart();
            },
            error: function(xhr, status, error) {
                console.error('Error adding to cart:', error);
            }
        });
    });

    // Cart quantity change
    $('.cart__qty-input').on('change', function() {
        var quantity = $(this).val();
        var line = $(this).data('quantity-item');
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            success: function(cart) {
                updateCart();
            },
            error: function(xhr, status, error) {
                console.error('Error updating cart:', error);
            }
        });
    });
});